import { jsx, jsxs } from "@emotion/react/jsx-runtime";
import { useTheme, css } from "@emotion/react";
import { Field } from "formik";
import FormFieldDescription from "./FormFieldDescription.mjs";
import FormFieldError from "./FormFieldError.mjs";
import FormFieldLabel from "./FormFieldLabel.mjs";
import FormFieldWrapper from "./FormFieldWrapper.mjs";
import { useThemeProps, handleComponentsProp, MaybeFragment } from "@wsui/base";
import Select from "./Select.mjs";
import { useTranslation } from "react-i18next";
function FormSelectField(props) {
  const theme = useTheme();
  const {
    t
  } = useTranslation();
  props = useThemeProps({
    props,
    name: "FormSelectField"
  });
  props = useThemeProps({
    props,
    name: "FormField"
  });
  let {
    inputProps = {},
    placeholder = t(["wsui.form.formSelectField.placeholder", "Select…"]),
    components,
    rowGap = [1, 2],
    options,
    type = "select",
    ...restProps
  } = props;
  let {
    Field: Field$1,
    FormFieldDescription: FormFieldDescription$1,
    FormFieldError: FormFieldError$1,
    FormFieldLabel: FormFieldLabel$1,
    FormFieldWrapper: FormFieldWrapper$1
  } = handleComponentsProp(components, {
    Field,
    FormFieldDescription,
    FormFieldError,
    FormFieldLabel,
    FormFieldWrapper
  });
  let {
    ...restInputProps
  } = inputProps;
  return /* @__PURE__ */jsx(FormFieldWrapper$1, {
    css: /* @__PURE__ */css("display:grid;grid-template-columns:1fr;grid-row-gap:", theme.getLength(rowGap), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:FormSelectField;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    type,
    ...restProps,
    children: _ref => {
      let {
        name,
        controlProps,
        wrapperProps,
        type: type2,
        id,
        multiple
      } = _ref;
      return /* @__PURE__ */jsxs(MaybeFragment, {
        ...wrapperProps,
        children: [/* @__PURE__ */jsx(FormFieldLabel$1, {}), /* @__PURE__ */jsx(FormFieldDescription$1, {}), /* @__PURE__ */jsx("div", {
          children: /* @__PURE__ */jsx(Field$1, {
            as: Select,
            type: type2,
            options,
            name,
            id,
            placeholder,
            multiple,
            ...controlProps,
            ...restInputProps
          })
        }), /* @__PURE__ */jsx(FormFieldError$1, {})]
      });
    }
  });
}
export { FormSelectField as default };